// External libraries

// CSS
import '../../styles/main.css'

// Components
import { Heading, TypographyColor, TypographyType, Card, CardSize, CardVariant, InfoPanel, Body, BodyType, BodyColor } from "../../ui-elements";


interface HighlightsProps {
    highlights: any[],
    infoTextData: any,
    shimmer?: boolean
}
export const Highlights = ({ highlights, infoTextData, shimmer }: HighlightsProps) => {
    // Function to convert subtitle text to camelCase key
    const toCamelCase = (text: string): string =>
        text
            ?.toLowerCase()
            .replace(/[^a-zA-Z0-9 ]/g, " ") // Replace special characters with spaces
            .replace(/\s+/g, " ") // Normalize multiple spaces
            .trim() // Trim leading/trailing spaces
            .split(" ") // Split words
            .map((word, index) =>
                index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
            )
            .join(""); // Join words together

    return (
        <div className="highlights-wrapper" >
            <div className='highlights no-scrollbar'>
                {highlights?.map((obj: any, index: number) => {
                    const camelCaseKey = toCamelCase(obj.subtitle); // Convert subtitle to camelCase
                    const infoText = infoTextData[camelCaseKey]; // Get corresponding info text
                    return (
                        <Card
                            size={CardSize.small}
                            variant={CardVariant.bordered}
                            classname="highlights-card p-1"
                            key={index}
                        >
                            <div
                                style={{
                                    backgroundColor: '#E5EBFE',
                                    display: 'flex',
                                    minHeight: '2.376vw',
                                    maxHeight: '2.376vw',
                                    minWidth: '2.376vw',
                                    maxWidth: '2.376vw',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    borderRadius: '50%',
                                    margin: '0 0.99vw'
                                }}
                            >

                                {(obj.type === "leading"
                                    ? <span className="material-symbols-outlined fs-23 " style={{ color: '#0030C7' }}>new_releases</span>
                                    //  
                                    : (obj.type === "growing" ?
                                        // <IoTrendingUpOutline className="fs-20" style={{ color: '#0030C7' }} />
                                        <span className="material-symbols-outlined fs-23 " style={{ color: '#0030C7' }}>trending_up</span>
                                        : (obj.type === 'count' ?
                                            <span className="material-symbols-outlined fs-23 " style={{ color: '#0030C7' }}>work</span>
                                            // <MdWorkOutline className='fs-20' style={{ color: '#0030C7' }} />
                                            :
                                            <span className="material-symbols-outlined fs-23 " style={{ color: '#0030C7' }}>location_on</span>
                                            // <CiLocationOn className='fs-20' style={{ color: '#0030C7' }} />
                                        ))
                                )}

                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', width: "14.144vw" }}>
                                <div
                                    className='w-100 d-flex flex-row align-items-center'
                                    style={{
                                        marginBottom: '2px'
                                    }}
                                >
                                    <div className={`single-poi-info-cardsss position-relative ${obj.type === "location" || obj.type === "count" ? 'w-100' : 'd-flex align-items-center'}`}
                                        style={{
                                            minWidth: obj.type === "location" || obj.type === "count" ? "100%" : "",
                                            maxWidth: obj.type === "location" || obj.type === "count" ? "100%" : "50%",
                                            // overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            width: 'fit-content'
                                        }}
                                    >
                                        <Heading
                                            title={obj.title ? obj.title : 'NA'}
                                            type={TypographyType.h4}
                                            colour={TypographyColor.primary}
                                            classname='ellipsis-text'
                                        />
                                        <div className="helper-highlight-text padding-left-right-2 padding-top-bottom-1 highlightshovertext ms-1">
                                            <Body
                                                type={BodyType.p2}
                                                color={BodyColor.white}
                                                classname="p-0 text-start"
                                            >
                                                {obj.title ? obj.title : 'NA'}
                                            </Body>
                                        </div>
                                    </div>
                                    {obj.title && obj.type !== "location" && obj.type !== "count" &&
                                        <div style={{ width: '50%' }} className='single-poi-info-cardsss position-relative'>
                                            <p
                                                className="d-flex justify-content-center align-items-center ps-3 pt-1 pb-1 pe-3 ms-2 highlightsvalue"
                                                style={{
                                                    borderRadius: '29px',
                                                    backgroundColor: obj.type === 'leading' ? '#E5EBFE' : '#E5EBFE',
                                                    fontWeight: '500',
                                                    fontSize: '10.5px',
                                                    margin: '0',
                                                    color: obj.type === 'leading' ? '#0030C7' : '#0030C7',
                                                    minWidth: 'fitContent',

                                                }}
                                            >
                                                {obj.value ? obj.value : '_ _ _'}
                                            </p>
                                            <div className="helper-highlight-text padding-left-right-2 padding-top-bottom-1 highlightshovertext ms-1">
                                                <Body
                                                    type={BodyType.p2}
                                                    color={BodyColor.white}
                                                    classname="p-0 text-start"
                                                >
                                                    {obj.value ? obj.value : '_ _ _'}
                                                </Body>
                                            </div>
                                        </div>

                                    }
                                </div>
                                <div className='w-100 d-flex flex-row'>
                                    <Heading
                                        title={obj.subtitle}
                                        type={TypographyType.h5}
                                        colour={TypographyColor.secondary}
                                        classname='ellipsis-text'
                                    />
                                    <InfoPanel text={infoText} classname='icon-color-5 margin-left-2 fs-18' />
                                </div>
                            </div>
                        </Card>
                    )
                }
                )}
            </div>
        </div >
    )
}

